import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

const heroImageSizes = imageSizes.columns5_34

const PageProductEnhancementCustomerArea: Definition = {
  contentType: 'PageProductEnhancementCustomerArea',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { sizes: heroImageSizes }
    },
    {
      id: 'benefits',
      name: 'Benefits',
      type: 'Array',
      subType: 'ModuleUsp'
    },
    {
      id: 'contentBlock1',
      name: 'Content block 1',
      type: 'BlockGroup',
      subType: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'contentBlock2',
      name: 'Content block 2',
      type: 'BlockGroup',
      subType: 'BlockTabContentLazy',
      lazy: true,
      imageOptions: { sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'contentBlock3',
      name: 'Content block 3',
      type: 'BlockGroup',
      subType: 'ModuleUsp'
    },
    {
      id: 'contentBlock4',
      name: 'Content block 4',
      type: 'BlockGroup'
    },
    {
      id: 'contentBlock4Image',
      name: 'Content block 4 Image',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns12_169, lazy: true }
    },
    {
      id: 'contentBlock4LogoBar',
      name: 'Content block 4 logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'contentBlock5',
      name: 'Content block 5',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'notificationBar',
      name: 'Notification Bar',
      type: 'BlockNotificationBar'
    }
  ]
}

export default {
  PageProductEnhancementCustomerArea
}
